import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_ME, Me } from '@frontend/data-access';
import { IdeaChannelCreatePhase } from '@frontend/feature-idea-channel';
import {
  DragDropContextProps,
  DragDropContext as DragDropContextRaw,
  DroppableProps,
  DroppableProvided,
  Droppable as DroppableRaw,
  DropResult,
} from '@hello-pangea/dnd';
import { Button, Empty } from 'antd';
import React, { useState } from 'react';
import { selectChannel } from '../../channel-store/selectors';
import { useAppSelector } from '../../channel-store/settings/hooks';
import KanbanColumn from '../column';

const DragDropContext =
  DragDropContextRaw as unknown as React.FC<DragDropContextProps>;
const Droppable = DroppableRaw as unknown as React.FC<DroppableProps>;

const KanbanBoard = ({
  onItemDragEnd,
}: {
  onItemDragEnd: (result: DropResult) => void;
}) => {
  const { data: meData } = useQuery<{ me: Me }>(GET_ME);
  const channel = useAppSelector(selectChannel);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePhaseCompleted = () => {
    handleModal();
  };

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const AddPhase = () => {
    return (
      <Button
        shape="circle"
        icon={<PlusOutlined />}
        onClick={handleModal}
      ></Button>
    );
  };

  if (!channel?.channelPhases) {
    return (
      <div className="w-full text-center p-5">
        <Empty />
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onItemDragEnd}>
      <Droppable
        droppableId="main-board"
        direction="horizontal"
        type="COLUMN"
        isCombineEnabled={false}
      >
        {(provided: DroppableProvided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={`flex gap-2 overflow-x-auto h-[calc(100vh_-_150px)]`}
          >
            {channel?.channelPhases.map((item, index) => (
              <KanbanColumn key={index} data={item} index={index} />
            ))}
            {meData?.me.role === 'ADMIN' && <AddPhase />}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <IdeaChannelCreatePhase
        open={isModalOpen}
        onCancel={handleModal}
        onFinish={handlePhaseCompleted}
        refetch={() => undefined}
      />
    </DragDropContext>
  );
};

export default KanbanBoard;
